// state.js

export default {
    
};
